import {
  DYNAMIC_MODAL_ACTIONS,
  DYNAMIC_MODAL_VIEWS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { reloadPage } from 'src/_shared/utils/reload-page/reloadPage';
import { allowAllExit } from 'src/_shared/utils/prevent-exit/preventExit.web';
import { ErrorView } from '../ErrorView';

export const NoAvailableSpaceError = () => {
  return (
    <ErrorView
      id="no-available-space-error"
      dynamicModalView={DYNAMIC_MODAL_VIEWS.NoAvailableSpace}
      actionCallback={(action: DYNAMIC_MODAL_ACTIONS) => {
        switch (action) {
          case DYNAMIC_MODAL_ACTIONS.CONTINUE:
            allowAllExit();
            reloadPage();
            break;
          default:
            break;
        }
      }}
    />
  );
};
